import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "rankingList",
  data: function data() {
    return {
      paramsData: {
        division_id: ''
      },
      tableData: [],
      total: 0,
      divisionList: [],
      value2: []
    };
  },
  created: function created() {
    this.getDivisionData();
  },
  methods: {
    datechange: function datechange() {
      if (this.value2 && this.value2.length > 0) {
        this.paramsData.start_time = this.value2[0];
        this.paramsData.end_time = this.value2[1];
      } else {
        this.paramsData.start_time = '';
        this.paramsData.end_time = '';
      }
    },
    getDivisionData: function getDivisionData() {
      var _this = this;

      this.$api.divisionList({
        page_size: -1
      }).then(function (res) {
        if (res.code == 200) {
          _this.divisionList = res.data;
        }
      });
    },
    getList: function getList() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this2.paramsData.division_id) {
                  _context.next = 3;
                  break;
                }

                _this2.$message.error("请选择赛区");

                return _context.abrupt("return");

              case 3:
                _this2.$api.ranking(_this2.paramsData).then(function (res) {
                  if (res.code == 200) {
                    var data = res.data;
                    _this2.tableData = data;

                    _this2.tableData.forEach(function (item) {
                      if (item.format_time != '0') {
                        item.duration = item.format_time;
                      } else {
                        item.duration = _this2.$utils.formatDuration(item.duration);
                      }
                    });
                  } else {
                    _this2.$message.error(res.msg);
                  }
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};